import { useMemo } from 'react';

import { type PermissionsMap, transformEffectivePermissionsToMap } from './permission-utils';

function getPersistedPermissions(): PermissionsMap | null {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (!persistRoot) return null;

    const userPersistData = JSON.parse(persistRoot);
    const authData = JSON.parse(userPersistData?.auth ?? '{}');
    const permissions = authData?.loginApiData?.permissions ?? null;

    if (Array.isArray(permissions)) {
      return transformEffectivePermissionsToMap(permissions);
    }
    return permissions;
  } catch {
    return null;
  }
}

export function getLoginPermissions(loginApiData: unknown): PermissionsMap | null {
  if (!loginApiData || typeof loginApiData !== 'object') return null;
  if (!('permissions' in loginApiData)) return null;

  const permissions = (loginApiData as any).permissions;
  if (!permissions) return null;

  if (Array.isArray(permissions)) {
    return transformEffectivePermissionsToMap(permissions);
  }

  if (typeof permissions !== 'object') return null;
  return permissions as PermissionsMap;
}

export function usePermissionsSource(loginApiData: unknown): PermissionsMap | null {
  return useMemo(() => {
    const loginPermissions = getLoginPermissions(loginApiData);
    const persistedPermissions = loginPermissions ? null : getPersistedPermissions();
    const resolved = loginPermissions ?? persistedPermissions;

    if (!resolved) return null;

    return {
      ...resolved,
    };
  }, [loginApiData]);
}
